// // context/SharedCrmContext.js
// import React, { createContext, useContext, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { selectUser, setCustomerCode } from "../ReduxStore/userReducer";
// import { CRMPostData } from "../ReduxStore/actions";
// import { getCustomerMaster } from "../ReduxStore/ItemPage/ItemPageThunk";
// // import { CRMPostData, setCustomerCode } from "../store/actions";

// const SharedCrmContext = createContext();

// export const SharedCrmProvider = ({ children }) => {
//     const userdata = useSelector(selectUser);
//     const [customerName, setCustomerName] = useState(null);
//     const [CustomerCodes, setCustomerCodes] = useState(null);
//     const { CustomerMaster } = useSelector((state) => state.CustomerMaster);
//     const databaseName = userdata?.DatabaseName;
//     const { fetchGuestCode } = useSelector((state) => state.greeterData);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//      const [searchTerm, setSearchTerm] = useState("");
//     const [customerCreation, setCustomerCreation] = useState([
//         {
//           PhoneNumber: "",
//           customerName: "",
//           customerCode: ""
//         },
//     ]);
//       const formdefault = {
//         existingcust: "",
//         WalkInType: '',
//         PhoneNo: "",
//         GreeterCode:"",
//         Reference: '',
//         LeadLevel: '',
//         AssignExecutive: userdata?.UserName,
//         ExecutiveId: userdata?.slpCode,
//         customerCategory: '',
//         Segment: [],
//         CustomerProfile: '',
//         SiteType: '',
//         CurrentWorkStatus: '',
//         ExpectedComplationOfWork: '',
//         ItemsChecked: [],
//         EstimatedValue: '',
//         ReqType: '',
//         ClosingDate: '',
//         SiteVist: '',
//         Address: '',
//         CustomerName: '',
//       }
//   const [formData, setFormData] = useState(formdefault);
//  const [formDataError, setFormDataError] = useState({
//     CustomerName: '',
//     PhoneNo: '',
//     WalkInType: '',
//     PhoneNo: "",
//     // GreeterCode:"",
//     Reference: '',
//     LeadLevel: '',
//     AssignExecutive: '',
//     ExecutiveId: '',
//     customerCategory: '',
//     Segment: [],
//     CustomerProfile: '',
//     SiteType: '',
//     CurrentWorkStatus: '',
//     ExpectedComplationOfWork: '',
//     ItemsChecked: [],
//     EstimatedValue: '',
//     ReqType: '',
//     SiteVist: '',
//     Address: ''
//   });
//   const [searchValue, setSearchValue] = useState("");
//   const dispatch = useDispatch();
//   useEffect(() => {
//     dispatch(getCustomerMaster(databaseName));
//   },[])

// const handleMainSelect = (selectedValue, fieldName, item) => {
//   debugger
//   console.log("selectedValue", selectedValue);
//   console.log("item", item);
//   console.log("formData", formData);
//   const updatedData = {
//     ...formData,
//     CustomerName:item.customerName || "",
//     CustomerProfile: item.u_CustProfile || "",
//     customerCategory: item.u_CustCategory || "",
//     PhoneNo:item.phoneNum || "",
//     LeadLevel: item.u_LeadLevel || "",
//     Reference: item.u_Reference || "",
//     WalkInType:item.u_WalkInType||"",
//   };
//   if (selectedValue && typeof selectedValue === "object") {
//     for (const [formFieldKey, itemKey] of Object.entries(selectedValue)) {
//       updatedData[formFieldKey] = item[itemKey] || "";
//     }
//   }
//   if (fieldName === "GreeterCode") {
//     if (item.CustomerCode==="") {
//       updatedData["existingcust"] = "NO";
//       setSearchTerm("");
//     } else {
//       updatedData["existingcust"] = "YES";
//       // dispatch(
//       //   setCustomerCode({
//       //     customerCode: item.CustomerCode || "",
//       //     customerName: item.CustomerName || "",
//       //     phoneNum: item.PhoneNumber || "",
//       //   })
//       // );
//     }
//   }
//   console.log("Final updatedData", updatedData);
//   setFormData(updatedData);
//   dispatch(CRMPostData(updatedData));
//   sessionStorage.setItem("CRMPostData", JSON.stringify(updatedData));
//   setDropdownOpen?.(false);

//   return true;
// };

//   const handleMainChange = (field, value) => {
//     const fieldName = field.field;
//     setFormData((prevData) => {
//         const updatedFormData = { 
//           ...prevData, 
//           [fieldName]: value, };
//         dispatch(CRMPostData(updatedFormData));
//         return updatedFormData;
//       });
//     // setFormErrors((prev) => ({
//     //   ...prev,
//     //   [fieldName]: "",
//     // }));
//   }

//   const validateForm = () => {
//     const errors = { ...formDataError };
//     let hasError = false;

//     // Clear previous errors
//     Object.keys(errors).forEach((key) => (errors[key] = ""));

//     if (formData.existingcust === "NO" && formData.CustomerName === "") {
//       errors.CustomerName = "Enter Customer Name";
//       hasError = true;
//     }

//     if (formData.PhoneNo === "") {
//       errors.PhoneNo = "Enter Phone Number";
//       hasError = true;
//     } else if (formData.PhoneNo.length < 10) {
//       errors.PhoneNo = "Phone Number must be at least 10 digits";
//       hasError = true;
//     }

//     if (formData.customerCategory === "") {
//       errors.customerCategory = "Enter Customer Category";
//       hasError = true;
//     }

//     if (formData.WalkInType === "") {
//       errors.WalkInType = "Enter Walk in Type";
//       hasError = true;
//     }

//     if (formData.Reference === "") {
//       errors.Reference = "Enter Reference";
//       hasError = true;
//     }

//     if (formData.LeadLevel === "") {
//       errors.LeadLevel = "Select Lead Level";
//       hasError = true;
//     }

//     if (formData.AssignExecutive === "") {
//       errors.AssignExecutive = "Select Assign Executive";
//       hasError = true;
//     }

//     if (formData.Segment.length === 0) {
//       errors.Segment = "Select segment";
//       hasError = true;
//     }

//     if (formData.CustomerProfile === "") {
//       errors.CustomerProfile = "Select Customer Profile";
//       hasError = true;
//     }

//     if (formData.SiteType === "") {
//       errors.SiteType = "Select Site Type";
//       hasError = true;
//     }

//     if (formData.CurrentWorkStatus === "") {
//       errors.CurrentWorkStatus = "Select Current Work Status";
//       hasError = true;
//     }

//     if (formData.ExpectedComplationOfWork === "") {
//       errors.ExpectedComplationOfWork = "Enter Valid Date";
//       hasError = true;
//     }

//     if (formData.ItemsChecked.length === 0) {
//       errors.ItemsChecked = "Select Items";
//       hasError = true;
//     }

//     if (formData.EstimatedValue === "") {
//       errors.EstimatedValue = "Enter Estimated Value";
//       hasError = true;
//     }

//     if (formData.ReqType === "") {
//       errors.ReqType = "Select Requirement Type";
//       hasError = true;
//     }

//     setFormDataError(errors);
//     return !hasError;  // ✅ Return true if no error, false if error found
//   };

// console.log("formDataError",formDataError);

//   return (
//     <SharedCrmContext.Provider
//       value={{
//         formData,
//         setFormData,
//         formDataError, setFormDataError,
//         dropdownOpen, setDropdownOpen,
//         searchValue, setSearchValue,
//         searchTerm, setSearchTerm,
//         handleMainSelect,
//         handleMainChange,validateForm
//         // updateSearchValue
//       }}
//     >
//       {children}
//     </SharedCrmContext.Provider>
//   );
// };

// export const useSharedCrm = () => useContext(SharedCrmContext);
import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../ReduxStore/userReducer";
import { CRMPostData } from "../ReduxStore/actions";
import { getCustomerMaster } from "../ReduxStore/ItemPage/ItemPageThunk";
const SharedCrmContext = createContext();
const initialFormErrors = {
  CustomerName: '',
  PhoneNo: '',
  WalkInType: '',
  Reference: '',
  LeadLevel: '',
  AssignExecutive: '',
  customerCategory: '',
  Segment: [],
  CustomerProfile: '',
  SiteType: '',
  CurrentWorkStatus: '',
  ExpectedComplationOfWork: '',
  ItemsChecked: [],
  EstimatedValue: '',
  ReqType: '',
  SiteVist: '',
  Address: ''
};
const initialFormData = {
  existingcust: "",
  WalkInType: '',
  PhoneNo: "",
  GreeterCode: "",
  Reference: '',
  LeadLevel: '',
  AssignExecutive: '',
  ExecutiveId: '',
  customerCategory: '',
  Segment: [],
  CustomerProfile: '',
  SiteType: '',
  CurrentWorkStatus: '',
  ExpectedComplationOfWork: '',
  ItemsChecked: [],
  EstimatedValue: '',
  ReqType: '',
  ClosingDate: '',
  SiteVist: '',
  Address: '',
  CustomerName: '',
};
export const SharedCrmProvider = ({ children }) => {
  const userdata = useSelector(selectUser);
  const databaseName = userdata?.DatabaseName;
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    ...initialFormData,
    AssignExecutive: userdata?.UserName || '',
    ExecutiveId: userdata?.slpCode || '',
  });
  const [formDataError, setFormDataError] = useState(initialFormErrors);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    if (formData.SiteVist === "YES") {
      setShowAddress(true);
    } else {
      setShowAddress(false);
    }
  }, [formData.SiteVist]);
  useEffect(() => {
    if (databaseName) {
      dispatch(getCustomerMaster(databaseName));
    }
  }, []);

  const handleMainSelect = (selectedValue, fieldName, item) => {
    const updatedData = {
      ...formData,
      CustomerProfile: item.u_CustProfile || "",
      customerCategory: item.u_CustCategory || "",
      PhoneNo: item.phoneNum || "",
      LeadLevel: item.u_LeadLevel || "",
      Reference: item.u_Reference || "",
      WalkInType: item.u_WalkInType || "",
      GreeterCode: item?.GuestCode || ""
    };
    if (selectedValue && typeof selectedValue === "object") {
      for (const [formFieldKey, itemKey] of Object.entries(selectedValue)) {
        updatedData[formFieldKey] = item[itemKey] || "";
      }
    }
    if (fieldName === "GreeterCode") {
      if (!item.customerCode) {
        updatedData["existingcust"] = "NO";
        updatedData.GreeterCode = item.GuestCode;
      } else {
        updatedData["existingcust"] = "YES";
        updatedData.GreeterCode = item.GuestCode;
      }
    } else if (fieldName === "PhoneNo" || fieldName === "CustomerName") {
      updatedData["existingcust"] = "YES";
    }
    setFormData(updatedData);
    dispatch(CRMPostData(updatedData));
    sessionStorage.setItem("CRMPostData", JSON.stringify(updatedData));
    setDropdownOpen(false);
    return true;
  };

  const handleMainChange = (field, value) => {
    const fieldName = field.field;
    setFormData((prevData) => {
      const updatedFormData = { ...prevData, [fieldName]: value };
      dispatch(CRMPostData(updatedFormData));
      return updatedFormData;
    });
  };
  const [scrollAddress, setScrollAddress] = useState(false);
  const [showAddress, setShowAddress] = useState(true);

  //   const handleFieldchange = ({ name, value, type, checked }) => {
  //     setFormDataError((prevErrors) => ({
  //       ...prevErrors,
  //       [name]: "", // Clear error for this field
  //     }));
  //     if (name === "EstimatedValue") {
  //       if (isNaN(value) || value === "") {
  //         alert("Please enter a valid number for EstimatedValue.");
  //         return;
  //       }
  //     }
  //     if (name === "SiteVist") {
  //       setFormData((prevData) => {
  //         let updatedFormData = { ...prevData };
  //         if (value === "YES") {
  //           setShowAddress(true);
  //           setScrollAddress(true);
  //           updatedFormData = {
  //             ...prevData,
  //             SiteVist: value,
  //           };
  //         } else if (value === "NO") {
  //           setShowAddress(false);
  //           setScrollAddress(false);
  //           updatedFormData = {
  //             ...prevData,
  //             SiteVist: value,
  //             Address: ""
  //           };
  //         }
  //         dispatch(CRMPostData(updatedFormData));
  //         return updatedFormData;
  //       });
  //       return;
  //     }

  //     if (type === "checkbox") {
  //       setFormData((prevData) => {
  //         const prevItems = Array.isArray(prevData.ItemsChecked)
  //           ? prevData.ItemsChecked
  //           : [];

  //         const updatedItems = checked
  //           ? [...prevItems, { itemCode: name, itemName: value }]
  //           : prevItems.filter((item) => item.itemCode !== name);

  //         const updatedFormData = {
  //           ...prevData,
  //           ItemsChecked: updatedItems,
  //         };
  //         dispatch(CRMPostData(updatedFormData));
  //         return updatedFormData;
  //       });

  //     } else {
  //       setFormData((prevData) => {
  //         let updatedFormData = {
  //           ...prevData,
  //           [name]: value, // Update the field value
  //         };
  //       if (name === "ReqType") {
  //         const currentDate = new Date();
  //         let closingDate;
  //         if (value === "By One Month") {
  //           currentDate.setDate(currentDate.getDate() + 15); // Add 15 days to the current date
  //           closingDate = currentDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
  //         }
  //         if (value === "By One Week") {
  //           currentDate.setDate(currentDate.getDate() + 3); // Add 15 days to the current date
  //           closingDate = currentDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
  //         }
  //         if (value === "Immediate") {
  //           currentDate.setDate(currentDate.getDate() + 1); // Add 15 days to the current date
  //           closingDate = currentDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
  //         }
  //         if (value === "Today") {
  //           currentDate.setDate(currentDate.getDate()); // Add 15 days to the current date
  //           closingDate = currentDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
  //         }
  //         updatedFormData.ClosingDate = closingDate; // Set the ClosingDate
  //       }
  //       dispatch(CRMPostData(updatedFormData)); // Dispatch the updated formData immediately
  //       return updatedFormData;
  //     });
  //   }
  // }
  const handleFieldchange = ({ name, value, type, checked }) => {

    setFormDataError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    let updatedFormData = { ...formData };
    if (name === "EstimatedValue") {
      const raw = value.replace(/[^\d.]/g, '')
      updatedFormData.EstimatedValue = raw;
      setFormData(updatedFormData)
      return
    }
    // if (name === "EstimatedValue") {
    //   if (isNaN(value) || value === "") {
    //     alert("Please enter a valid number for EstimatedValue.");
    //     return;
    //   }
    // }
    if (name === "SiteVist") {
      if (value === "YES") {
        setShowAddress(true);
        setScrollAddress(true);
        updatedFormData.SiteVist = value;
      } else if (value === "NO") {
        setShowAddress(false);
        setScrollAddress(false);
        updatedFormData = {
          ...updatedFormData,
          SiteVist: value,
          Address: "",
        };
      }
    }
    if (type === "checkbox" && name !== "SiteVist") {
      const prevItems = Array.isArray(updatedFormData.ItemsChecked)
        ? updatedFormData.ItemsChecked
        : [];

      updatedFormData.ItemsChecked = checked
        ? [...prevItems, { itemCode: name, itemName: value }]
        : prevItems.filter((item) => item.itemCode !== name);
    }
    // Handle other fields
    else {
      updatedFormData[name] = value;
      if (name === "ReqType") {
        // updatedFormData.ClosingDate = closingDate;
        const closingDate = calculateClosingDate(value); // Call the function to calculate ClosingDate
        updatedFormData.ClosingDate = closingDate; // Set the closing date
        updatedFormData.ReqType = value; // Set the updated ReqType

      }
    }
    setFormData(updatedFormData);
    dispatch(CRMPostData(updatedFormData));
    return updatedFormData;
  };
  const calculateClosingDate = (reqType) => {
    const currentDate = new Date();
    let closingDate;

    switch (reqType) {
      case "By One Month":
        currentDate.setDate(currentDate.getDate() + 15); // Add 15 days
        break;
      case "By One Week":
        currentDate.setDate(currentDate.getDate() + 3); // Add 3 days
        break;
      case "Immediate":
        currentDate.setDate(currentDate.getDate() + 1); // Add 1 day
        break;
      case "Today":
        // No date change needed
        break;
      default:
        break;
    }

    closingDate = currentDate.toISOString().split('T')[0]; // Format date as YYYY-MM-DD
    return closingDate;
  };


  const validateForm = () => {
    const errors = { ...initialFormErrors };
    let hasError = false;

    // if (!formData.GreeterCode.trim()) {
    //   errors.CustomerName = "Select GreeterCode";
    //   hasError = true;
    // }
    if(formData.existingcust === "NO"){
    if (!formData.CustomerName.trim()) {
      errors.CustomerName = "Enter Customer Name";
      hasError = true;
    }

    if (!formData.PhoneNo) {
      errors.PhoneNo = "Enter Phone Number";
      hasError = true;
    } else if (formData.PhoneNo.length < 10) {
      errors.PhoneNo = "Ph.No must be at least 10 digits";
      hasError = true;
    }

    if (!formData.customerCategory) {
      errors.customerCategory = "Enter Customer Category";
      hasError = true;
    }

    if (!formData.WalkInType) {
      errors.WalkInType = "Enter Walk in Type";
      hasError = true;
    }

    if (!formData.Reference) {
      errors.Reference = "Enter Reference";
      hasError = true;
    }

    if (!formData.LeadLevel) {
      errors.LeadLevel = "Select Lead Level";
      hasError = true;
    }
    
    if (!formData.CustomerProfile) {
      errors.CustomerProfile = "Select Customer Profile";
      hasError = true;
    }
    if (!formData.AssignExecutive) {
      errors.AssignExecutive = "Select Assign Executive";
      hasError = true;
    }
  }
    if (formData.Segment.length === 0) {
      errors.Segment = "Select segment";
      hasError = true;
    }


    if (!formData.SiteType) {
      errors.SiteType = "Select Site Type";
      hasError = true;
    }

    if (!formData.CurrentWorkStatus) {
      errors.CurrentWorkStatus = "Select Current Work Status";
      hasError = true;
    }

    if (!formData.ExpectedComplationOfWork) {
      errors.ExpectedComplationOfWork = "Enter Valid Date";
      hasError = true;
    }

    // if (formData.ItemsChecked.length === 0) {
    //   errors.ItemsChecked = "Select Items";
    //   hasError = true;
    // }

    if (!formData.EstimatedValue) {
      errors.EstimatedValue = "Enter Estimated Value";
      hasError = true;
    }

    if (!formData.ReqType) {
      errors.ReqType = "Select Requirement Type";
      hasError = true;
    }

    setFormDataError(errors);
    return !hasError;
  };

  const contextValue = useMemo(() => ({
    formData,
    setFormData,
    initialFormData,
    formDataError,
    setFormDataError,
    dropdownOpen,
    setDropdownOpen,
    searchValue,
    setSearchValue,
    searchTerm,
    setSearchTerm,
    handleMainSelect,
    handleMainChange,
    handleFieldchange,
    validateForm, showAddress, calculateClosingDate
  }), [
    formData,
    formDataError,
    dropdownOpen,
    searchValue,
    searchTerm
  ]);

  return (
    <SharedCrmContext.Provider value={contextValue}>
      {children}
    </SharedCrmContext.Provider>
  );
};

export const useSharedCrm = () => useContext(SharedCrmContext);
